import React from 'react';
import { useTranslation } from 'react-i18next';
import { buildEventViewModel } from 'stores/events/event-form-store';
import { EventDto } from 'stores/events/events-store';
import MobileEventElementContainer from './mobile-event-element-container';

interface Props {
  events: EventDto[];
  onEventClick: (event?: EventDto) => void;
  onBack?: () => void;
}

const MobileEventList: React.FC<Props> = ({ events, onEventClick, onBack }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 p-2">
      {(events || []).length > 0 ? (
        (events || []).map((item, i) => (
          <MobileEventElementContainer
            key={i}
            event={buildEventViewModel(item)}
            selectedEvent={item}
            onClick={i => {
              onEventClick(i);
            }}
          />
        ))
      ) : (
        <div className="p-4  relative">
          <div className="flex items-center mb-2">
            <button
              onClick={() => {
                onBack && onBack();
              }}
              className="flex items-center gap-1 text-sm text-black-600"
            >
              ← Back
            </button>
          </div>
          <div className="flex justify-center items-center p-4 text-gray-500">{t('No events available for selection')}.</div>
        </div>
      )}
    </div>
  );
};

export default MobileEventList;
